/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { connect } from 'react-redux'
import { Formik, Form, Field, ErrorMessage, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { Dispatcher, IMenu, IMenuEditModel, ITag, RootState } from 'AppTypes'
import { MenuEditModel } from '@app/models'
import * as menuActions from './state_management/actions'

const mapStateToProps = (state: RootState) => ({
  editedMenu: state.menu.editedMenu,
  menuTypes: state.menu.menuTypes,
  uploadVideoFile: state.menu.uploadVideoFile,
  uploadVideoUrl: state.menu.uploadVideoUrl,
  uploadImageFiles: state.menu.uploadImageFiles,
  uploadImageUrls: state.menu.uploadImageUrls,
  tags: state.menu.tags,
  allergens: state.menu.allergens,
  tagSuggestions: state.menu.tagSuggestions
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  createMenu: (menu: IMenuEditModel) => dispatch(menuActions.createMenu(menu)),
  addTag: (tag: string) => dispatch(menuActions.addTag(tag)),
  removeTag: (tag: string) => dispatch(menuActions.removeTag(tag)),
  addAllergen: (allergen: string) => dispatch(menuActions.addAllergen(allergen)),
  removeAllergen: (allergen: string) => dispatch(menuActions.removeAllergen(allergen)),
  changeVideo: (file: File) => dispatch(menuActions.changeVideo(file)),
  removeVideo: () => dispatch(menuActions.removeVideo()),
  changeImages: (files: File[]) => dispatch(menuActions.changeImages(files)),
  removeImage: (url: string) => dispatch(menuActions.removeImage(url)),
  fetchTags: (keyword: string) => dispatch(menuActions.fetchTagSuggestions(keyword)),
  setLoading: (isLoading: boolean) => dispatch(menuActions.setLoading(isLoading))
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const MenuEditor: React.FC<Props> = ({
  editedMenu,
  menuTypes,
  uploadVideoFile,
  uploadVideoUrl,
  uploadImageFiles,
  uploadImageUrls,
  tags,
  allergens,
  tagSuggestions,
  addTag,
  removeTag,
  addAllergen,
  removeAllergen,
  createMenu,
  changeVideo,
  removeVideo,
  changeImages,
  removeImage,
  fetchTags,
  setLoading
}) => {
  const { t } = useTranslation()

  const onTagClick = (tag: string) => {
    removeTag(tag)
  }

  const onTagSelected = (tag: ITag, setFieldValue: any) => {
    // TODO: implement tag selected
    addTag(tag.tagName)
    setFieldValue('tagInput', '')
  }

  const onTagChange = (e: { key: string, currentTarget: HTMLInputElement }, setFieldValue: any) => {
    if (e.key === 'Enter') {
      addTag(e.currentTarget.value)
      setFieldValue('tagInput', '')
    } else if (e.currentTarget.value.length > 1) {
      fetchTags(e.currentTarget.value)
    }
  }

  const onAllergenClick = (allergen: string) => {
    removeAllergen(allergen)
  }

  const onAllergenEnter = (e: { key: string, currentTarget: HTMLInputElement }, setFieldValue: any) => {
    if (e.key === 'Enter') {
      addAllergen(e.currentTarget.value)
      setFieldValue('allergenInput', '')
    }
  }

  const onVideoChange = (e: { currentTarget: HTMLInputElement}) => {
    if (e.currentTarget.files?.[0]) {
      changeVideo(e.currentTarget.files[0])
    }
  }

  const onRemoveVideo = () => {
    removeVideo()
  }

  const onImagesChange = (e: { currentTarget: HTMLInputElement }) => {
    if (e.currentTarget.files && e.currentTarget.files.length > 0) {
      changeImages(Array.from(e.currentTarget.files))
    }
  }

  const onRemoveImage = (url: string) => {
    removeImage(url)
  }

  const initVal = {
    ...editedMenu,
    publicStatus: editedMenu.isPublish ? 'public' : 'private'
  }

  const onSubmit = (values: any) => {
    setLoading(true)

    const editModel = new MenuEditModel()
    editModel.menuName = values.menuName
    editModel.price = values.price
    editModel.description = values.description
    editModel.menuTypeId = values.menuTypeId
    editModel.isPublish = values.publicStatus === 'public' || true

    createMenu(editModel)
  }

  const validationSchema = Yup.object().shape({
    menuName: Yup.string()
      .required(t('menuPage.requiredMessage'))
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initVal}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        onSubmit(values)
        actions.setSubmitting(false)
      }}
    >{
        ({ values, submitForm, setFieldValue }) => (
          <>
            <Form>
              <h3><img src="/assets/img/shop-ui_icon_menu-red.png" alt={t('menuPage.menuRegistration')} /> {t('menuPage.menuRegistration')}</h3>
              <div className="row form-group">
                <label className="col-3 col-form-label" htmlFor="menuName">{t('menuPage.menuName')}</label>
                <div className="col-8">
                  <Field id="menuName" name="menuName" className="form-control" type="text" placeholder={t('menuPage.pleaseEnter')} />
                  <ErrorMessage name="menuName" />
                </div>
              </div>
              <div className="row form-group">
                {/* eslint-disable-next-line no-irregular-whitespace */}
                <label className="col-3 col-form-label" htmlFor="price">{t('menuPage.price')}</label>
                <div className="col-8 d-flex align-items-center">
                  <Field id="price" name="price" className="form-control w-50 mr-2" type="number" placeholder={t('menuPage.pleaseEnter')} /> 円
                </div>
              </div>
              <div className="row form-group">
                <label className="col-3 col-form-label" htmlFor="description">{t('menuPage.description')}</label>
                <div className="col-8">
                  <Field as="textarea" id="description" name="description" className="form-control" rows={3} placeholder={t('menuPage.pleaseEnter')} />
                </div>
              </div>
              <div className="row form-group">
                {/* eslint-disable-next-line no-irregular-whitespace */}
                <label className="col-3 col-form-label" htmlFor="video">{t('menuPage.video')}</label>
                <div className="col-9">
                  <div className="d-flex mt-2">
                    <Field type="file" id="video" name="videoInput" hidden accept=".mp4,.mov,.mpeg" onChange={onVideoChange} />
                    <label className="custom-input-file" htmlFor="video">{t('menuPage.selectFile')}</label>
                    <div style={{ lineHeight: 1.5, fontSize: '15px', color: '#000', marginLeft: '1rem', width: '240px' }}>MP4,{t('menuPage.videoFileTypeMsg')}<br /> {t('menuPage.videoFileCountLimitMsg')}</div>
                  </div>
                  {
                    uploadVideoUrl != null
                    && uploadVideoUrl !== ''
                    && <div className="video-preview-container"><div className="video-preview"><button onClick={onRemoveVideo} type="button" className="btn-remove">x</button><video controls><source src={uploadVideoUrl} /><track kind="captions" /></video></div></div>
                  }
                </div>
              </div>
              <div className="row form-group">
                {/* eslint-disable-next-line no-irregular-whitespace */}
                <label className="col-3 col-form-label" htmlFor="images">{t('menuPage.images')}</label>
                <div className="col-9">
                  <div className="d-flex mt-2">
                    <Field type="file" id="images" name="imagesInput" hidden multiple accept="image/*" onChange={onImagesChange} />
                    <label className="custom-input-file" htmlFor="images">{t('menuPage.selectFile')}</label>
                    <div style={{ lineHeight: 1.5, fontSize: '15px', color: '#000', marginLeft: '1rem', width: '240px' }}>MP4,{t('menuPage.videoFileTypeMsg')}<br /> {t('menuPage.videoFileCountLimitMsg')}</div>
                  </div>
                  {
                    uploadImageUrls != null
                    && uploadImageUrls.length > 0
                    && (
                      <div className="images-preview-container">
                        {
                          uploadImageUrls.map(
                            url => (
                              <div className="images-preview" key={url}>
                                <button onClick={() => onRemoveImage(url)} type="button" className="btn-remove">x</button>
                                <img src={url} alt="" />
                              </div>
                            )
                          )
                        }
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="row form-group">
                <label className="col-3 col-form-label" htmlFor="selCategory">{t('menuPage.category')}</label>
                <div className="col-9 d-flex">
                  <Field as="select" id="selCategory" name="menuTypeId" className="form-control w-50">
                    <option>{t('menuPage.pleaseEnter')}</option>
                    {menuTypes.map(type => <option value={type.id} key={type.id}>{type.name}</option>)}
                  </Field>
                  <svg className="svg-inline--fa fa-plus-circle fa-w-16 icon-add" aria-hidden="true" data-prefix="fas" data-icon="plus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" /></svg>
                </div>
              </div>
              <div className="row form-group">
                {/* eslint-disable-next-line no-irregular-whitespace */}
                <label className="col-3 col-form-label" htmlFor="txtTag">{t('menuPage.tag')}</label>
                <div className="col-8">
                  <Field
                    id="txtTag"
                    name="tagInput"
                    className="form-control"
                    type="text"
                    placeholder={t('menuPage.pleaseEnter')}
                    autoComplete="off"
                    onKeyUp={(e: { key: string, currentTarget: HTMLInputElement }) => onTagChange(e, setFieldValue)}
                  />
                  {tagSuggestions
                    && tagSuggestions.length > 0
                    && (
                      <div className="tag-suggestion">
                        <ul>
                          {tagSuggestions.map(tag =>
                            <li key={tag.id} onClick={() => onTagSelected(tag, setFieldValue)}>{tag.tagName}</li>)}
                        </ul>
                      </div>
                    )}
                  <div className="tags mt-2" style={{ maxWidth: '300px' }}>
                    {
                      tags?.map(
                        tag =>
                          <button onClick={() => onTagClick(tag)} key={tag} type="button" className="btn btn-general btn-yellow btn-sm" disabled={false}>{tag}</button>
                      )
                    }
                  </div>
                  <div className="d-flex align-items-center mt-2">
                    <svg className="svg-inline--fa fa-question-circle fa-w-16 mr-3" style={{ fontSize: '40px', color: '#FF3050' }} aria-hidden="true" data-prefix="fas" data-icon="question-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z" /></svg>
                    <div className="text">{t('menuPage.tagNote')}</div>
                  </div>
                </div>
              </div>
              <div className="row form-group">
                <label className="col-3 col-form-label" htmlFor="txtAllergic">{t('menuPage.allergens')}</label>
                <div className="col-8">
                  <Field
                    id="txtAllergic"
                    name="allergenInput"
                    className="form-control"
                    type="text"
                    placeholder={t('menuPage.pleaseEnter')}
                    onKeyUp={(e: { key: string, currentTarget: HTMLInputElement }) => onAllergenEnter(e, setFieldValue)}
                  />
                  <div className="tags mt-2" style={{ maxWidth: '300px' }}>
                    {
                      allergens?.map(
                        alg =>
                          <button onClick={() => onAllergenClick(alg)} key={alg} type="button" className="btn btn-general btn-yellow btn-sm" disabled={false}>{alg}</button>
                      )
                    }
                  </div>
                </div>
              </div>
              <div className="row form-group mt-3">
                <label className="col-3 col-form-label" htmlFor="isPublish">{t('menuPage.publicSetting')}</label>
                <div className="col-8">
                  <div className="btn-group btn-group-toggle" data-toggle="buttons">
                    <label className={values.publicStatus === 'public' ? 'btn active' : 'btn'} htmlFor="option_a1">
                      <Field type="radio" name="publicStatus" value="public" id="option_a1" autoComplete="off" /> {t('menuPage.public')}
                    </label>
                    <label className={values.publicStatus === 'private' ? 'btn active' : 'btn'} htmlFor="option_a2">
                      <Field type="radio" name="publicStatus" value="private" id="option_a2" autoComplete="off" /> {t('menuPage.private')}
                    </label>
                  </div>
                </div>
              </div>
            </Form>
            <div className="mt-4 text-center">
              <button type="submit" className="btn bg-danger w-75" onClick={submitForm}>{t('menuPage.save')}</button>
            </div>
          </>
        )
      }
    </Formik>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuEditor)
